import { Box, BoxProps, styled, StyledComponent, themeGet, withDefaults } from '@qwealth/qcore';

export const StyledLabel = withDefaults<BoxProps>({
  as: 'label',
  display: 'grid',
  gridGap: 'small',
  textStyle: 'formLabel',
})(Box) as StyledComponent<BoxProps, HTMLLabelElement>;

export const LabelValueRow = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: ${themeGet('space.default')};
  align-items: flex-start;

  .info-label {
    font-weight: ${themeGet('fontWeights.bold')};
    font-size: ${themeGet('fontSizes.small')};
    flex-shrink: 0;
  }

  .info-value {
    font-size: ${themeGet('fontSizes.small')};
    min-width: 0;
    white-space: normal;
    word-break: break-word;
  }

  .nowrap-date {
    white-space: nowrap;
  }
`;

export const LoaderOverlay = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${themeGet('colors.primaryTransparent')};
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;
